import React from 'react'
import Navbar from '../Navbar/Navbar'
import Footer from '../Footer/Footer'
import Products from '../Products/Products'

export default function ElectronicProducts() {
  return (
    <div>
      {/* <Navbar/> */}
      <Products/>
      <Footer/>
    </div>
  )
}
